import { render, staticRenderFns } from "./ConversationalAgentChat.vue?vue&type=template&id=274454f0&scoped=true"
import script from "./ConversationalAgentChat.vue?vue&type=script&lang=js"
export * from "./ConversationalAgentChat.vue?vue&type=script&lang=js"
import style0 from "./ConversationalAgentChat.vue?vue&type=style&index=0&id=274454f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274454f0",
  null
  
)

export default component.exports